import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import { Icon } from '@pella/sash-framework';

import './slick-carousel.css';
import styles from './index.module.scss';

// Prev Arrow
const PrevArrow = (props) => {
	let { className, onClick, hasContainer } = props;

	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- fix this
		<div
			onClick={onClick}
			className={`${hasContainer ? className.replace('slick-disabled', '') : className} ${styles.slider_PrevArrow} slider_PrevArrow`}
		>
			<span className={styles.srOnly}>Previous</span>
			<Icon name='keyboard_arrow_left' />
		</div>
	);
};

PrevArrow.propTypes = {
	className: PropTypes.string,
	onClick: PropTypes.func,
	hasContainer: PropTypes.bool,
};

// Next Arrow
const NextArrow = (props) => {
	const { className, onClick } = props;
	return (
		// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions -- fix this
		<div
			onClick={onClick}
			className={`${className} ${styles.slider_NextArrow} slider_NextArrow`}
		>
			<span className={styles.srOnly}>Next</span>
			<Icon name='keyboard_arrow_right' />
		</div>
	);
};

NextArrow.propTypes = {
	className: PropTypes.string,
	hasContainer: PropTypes.bool,
	onClick: PropTypes.func,
};

class SlickSlider extends Component {
	constructor(props) {
		super(props);

		this.state = {
			loading: true,
		};
	}

	componentDidMount() {
		this.setState({
			loading: false,
		});
	}

	render() {
		const { hasContainer, children, ...other } = this.props;

		const settings = {
			dots: true,
			dotsClass: `${styles.slider_Dots} slider_Dots`,
			infinite: false,
			speed: 500,
			slidesToScroll: 1,
			lazyLoad: true,
			nextArrow: <NextArrow hasContainer={hasContainer} />,
			prevArrow: <PrevArrow hasContainer={hasContainer} />,
		};

		return (
			!this.state.loading && (
				<Slider
					className={hasContainer && `${styles.hasContainer}`}
					{...settings}
					{...other}
				>
					{children}
				</Slider>
			)
		);
	}
}

SlickSlider.propTypes = {
	children: PropTypes.node,
	hasContainer: PropTypes.bool,
};

export default SlickSlider;
